import { DataTableCol } from "../../../components/data-table/types";

export const LogsGridData: DataTableCol[] = [
    {
        title: 'S.NO',
        control: 'id',
        sortable: false,
    },
    {
        title: 'File Name',
        control: 'file_name',
        sortable: false,
        type: 'link',
        action: 'link'
    },
];